import uuid4 from "uuid4";

export function parseWebSocketMessage(rawData, { ignoreSpecial = false } = {}) {
    let payload;
    try {
        payload = JSON.parse(rawData);
    } catch (e) {
        const text = typeof rawData === 'string' ? rawData.trim() : null;
        if (text && (ignoreSpecial || !text.includes('@'))) {
            return { type: 'stream', text };
        }
        return { type: 'ignore' };
    }

    console.log('[chatMessageUtils] 🚀 ', JSON.stringify(payload, null, 2));
    
    const conversationId = payload?.conversation_id;

    if (payload && payload.type === 'history') {
        if (payload.entryType === 'api') {
            // Bot stores both a plain-text preview and the api entry for the same turn.
            // Treat history api entries as real api messages (formatted) and signal
            // the caller to pop the preceding plain-text preview first.
            const message = {
                id: uuid4(),
                type: 'api',
                name: payload.name,
                result: payload.result,
                text: payload.string,
                user: 'bot',
                timestamp: new Date().toISOString(),
            };
            return { type: 'history_api', message, conversationId };
        }
        const message = {
            id: uuid4(),
            type: 'text',
            text: payload.string,
            user: payload.role === 'user' ? 'user' : 'bot',
            timestamp: new Date().toISOString(),
        };
        return { type: 'history', message, conversationId };
    }

    if (payload && payload.type === 'api') {
        // Bot replays the last api result when restoring a conversation.
        // history_api already handled it — skip the replay to avoid duplicates.
        if (payload.replay === true) return { type: 'ignore', conversationId };
        const message = {
            id: uuid4(),
            type: 'api',
            name: payload.name,
            result: payload.result,
            text: payload.string,
            user: 'bot',
            timestamp: new Date().toISOString(),
        };
        return { type: 'api', message, conversationId };
    }
    
    console.log('[{chatMessageUtils}] 🚀 ', JSON.stringify({isFinal: payload.type === 'final', isArray: Array.isArray(payload.string)}, null, 2));

    if (payload && payload.type === 'final' && Array.isArray(payload.string)) {
        const entities = {};
        payload.string.forEach(str => {
            const firstSpaceIndex = str.indexOf(' ');
            if (firstSpaceIndex === -1) return;
            let key = str.substring(0, firstSpaceIndex);
            const value = str.substring(firstSpaceIndex + 1);
            if (key.startsWith('@')) key = key.substring(1);
            if (key) entities[key] = value;
        });
        return { type: 'entities', entities, conversationId };
    }

    if (payload && payload.string) {
        let text = null;
        if (Array.isArray(payload.string)) {
            text = payload.string.map(v => String(v).trim()).filter(Boolean).join(' | ');
        } else if (typeof payload.string === 'string') {
            text = payload.string.trim();
        }
        
        console.log('[chatMessageUtils text] 🚀 ', JSON.stringify(text, null, 2));
        
        if (text && (ignoreSpecial || (!text.includes('@') && !text.includes('{#')))) {
            return { type: 'stream', text, conversationId };
        }
    }

    return { type: 'ignore' };
}

export function buildSendPayload(message) {
    if (message.type === 'text') {
        return { type: 'text', text: message.text };
    }
    if (message.type === 'image' || message.type === 'file') {
        const base64Content = message.content.split(',')[1];
        return { type: 'file', filename: message.filename, content_b64: base64Content };
    }
    return null;
}

export function createChat(scenario, conversationId = null) {
    const id = uuid4();
    return {
        id,
        name: scenario.name,
        displayName: `${scenario.name} (${id.slice(id.length - 5, id.length)})`,
        messages: [],
        entities: {},
        isBotTyping: false,
        conversationId,
    };
}
